<app-ship-details
  *ngIf="ship"
  [shipData]="ship"
  [shipResultArray]="shipResultArray"
  (newShipSelectedEmitter)="onShipChange($event)"
>
</app-ship-details>
<div *ngIf="decrypting" class="decrypting-modal"></div>
<div *ngIf="decrypting" class="decrypting-content">
  <i class="fa fa-spinner fa-pulse fa-4x fa-fw"></i>
  <span>Decrypting...</span>
</div>
<div class="info-msg">
  <div *ngIf="!isNotEMV()">
    Marine Bulk Enrollment is only to be used for ordering Legacy Cards. Do not use Marine Bulk Enrollment for EMV
    cards.
  </div>
</div>
<div
  class="fileUpload"
  *ngIf="!fileSelected && hasEntitlement('TAB_MARINES_BULK_ENROLLMENT') && isNotEMV()"
>
  <div class="info-msg">
    <div *ngIf="!uploadSuccess">
      This page is used for uploading bulk enrollment data for card ordering.
      Please upload a CSV file by clicking on the button below. If the file is
      encrypted, please ensure the filename has an extension of .csv.enc -
      otherwise, it should have an extension of just .csv.
    </div>
    <div class="upload-success" *ngIf="uploadSuccess">
      Enrollment data file uploaded successfully!
    </div>
  </div>
  <div *ngIf="csvErrorMsg != ''" class="error-msg">
    {{ csvErrorMsg }}
  </div>
  <div class="upload">
    <input
      title="Upload CSV file to create card order"
      type="file"
      id="theCsvFile"
      name="csvFile"
      accept=".enc,.csv"
      (change)="handleFileInput($event.target.files)"
    />
  </div>
</div>
<div>
  <div class="cancel" *ngIf="fileSelected">
    <button
      (click)="upload()"
      class="btn btn-info btnSubmit"
      *ngIf="fileSelected && failedRecordCount < 1"
    >
      Order Cards
    </button>
    <button
      (click)="downloadData()"
      class="btn btn-secondary btnSubmit"
      *ngIf="fileSelected"
    >
      Download Data
    </button>
    <button class="btn btn-primary btnCancel" (click)="cancel()">
      Cancel / Clear
    </button>
    <div *ngIf="fileSelected && failedRecordCount < 1" class="missing-info-msg">
      No issues found ... Please click on 'Order Cards' to submit the enrollment
      data.
    </div>
    <div *ngIf="failedRecordCount > 0" class="missing-info-msg">
      There are <strong class="danger">{{ failedRecordCount }}</strong> rows
      marked with <i class="fa fa-times danger">&nbsp;</i> that have an issue
      with the enrollment data provided ... Please correct the data and try
      uploading again.
    </div>
  </div>
</div>
<div class="output" *ngIf="enrolleeData.length > 0">
  <table>
    <thead>
    <tr>
      <th>&nbsp;</th>
      <th>Last Name</th>
      <th>First Name</th>
      <th>Middle</th>
      <th>SSN</th>
      <th>DOB</th>
      <th>Mother's Maiden</th>
      <th>Salutation</th>
      <th>Pay Grade</th>
      <th>Branch</th>
      <th>Address 1</th>
      <th>City</th>
      <th>State</th>
      <th>Zip</th>
      <th>Country</th>
      <th>Phone</th>
      <th>Email</th>
      <th>Bank ABA</th>
      <th>Bank Account</th>
      <th>Bank Account Name</th>
      <th>Account Type</th>
      <th>MEU</th>
    </tr>
    </thead>
    <tbody>
    <tr
      *ngFor="let rec of enrolleeData"
      [ngClass]="{ bordered: rec && !rec.valid }"
    >
      <td>
        <i *ngIf="rec && !rec.valid" class="fa fa-times">&nbsp;</i>
        <i *ngIf="rec && rec.valid" class="fa fa-check">&nbsp;</i>
      </td>
      <td>{{ rec && rec.lastName }}</td>
      <td>{{ rec && rec.firstName }}</td>
      <td>{{ rec && rec.middleName }}</td>
      <td>{{ rec && rec.ssn }}</td>
      <td>{{ rec && rec.dob }}</td>
      <td>{{ rec && rec.mothersMaiden }}</td>
      <td>{{ rec && rec.salutation }}</td>
      <td>{{ rec && rec.payGrade }}</td>
      <td>{{ rec && rec.militaryBranch }}</td>
      <td>{{ rec && rec.addressLine1 }}</td>
      <td>{{ rec && rec.city }}</td>
      <td>{{ rec && rec.state }}</td>
      <td>{{ rec && rec.zip }}</td>
      <td>{{ rec && rec.country }}</td>
      <td>{{ rec && rec.phone }}</td>
      <td>{{ rec && rec.email }}</td>
      <td>{{ rec && rec.bankAba }}</td>
      <td>{{ rec && rec.bankAccount }}</td>
      <td>{{ rec && rec.bankAccountName }}</td>
      <td>{{ rec && rec.accountType }}</td>
      <td>{{ rec && rec.meu }}</td>
    </tr>
    </tbody>
  </table>
</div>
